/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // ── Variant media swap (product page + featured product, not quick buy) ───
  // When the selected variant changes, replace the product gallery with either:
  //   • the variant's metafield images  (custom.zdjecia_wariantu)
  //   • or the default product.media
  // The correct HTML for each group is pre-rendered server-side inside a
  // <template id="ProductMediaStore--UNIQUE"> element (inert DocumentFragment).
  // DOM swap + Flickity reinit run in theme.dev.js (destroy must happen before replaceChildren).

  const getGalleryUnique = (section) => {
    const gallery = section.querySelector('[data-product-single-media-group]');
    if (gallery?.id?.startsWith('ProductPhoto--')) {
      return gallery.id.replace('ProductPhoto--', '');
    }

    return section.querySelector('[data-product]')?.dataset?.sectionId || section.dataset?.sectionId || null;
  };

  document.addEventListener('theme:variant:change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    const section = event.target.closest(
      '[data-section-type="product-template"], [data-section-type="featured-product"]'
    );
    if (!section) return;

    const galleryUnique = getGalleryUnique(section);
    if (!galleryUnique) return;

    const storeTemplate = document.getElementById(`ProductMediaStore--${galleryUnique}`);
    if (!storeTemplate) return;

    const variantMediaGroup = storeTemplate.content.querySelector(
      `[data-media-group="variant-${variant.id}"]`
    );
    const mediaGroup =
      variantMediaGroup || storeTemplate.content.querySelector('[data-media-group="default"]');

    if (!mediaGroup) return;

    const galleryKey = variantMediaGroup ? `variant-${variant.id}` : 'default';
    if (section.dataset.activeGallery === galleryKey) return;
    section.dataset.activeGallery = galleryKey;

    // Use default thumbs only for the default gallery — not when variant has its own metafield images
    let thumbsGroup = null;
    if (variantMediaGroup) {
      thumbsGroup = storeTemplate.content.querySelector(
        `[data-thumbs-group="variant-${variant.id}"]`
      );
    } else {
      thumbsGroup = storeTemplate.content.querySelector('[data-thumbs-group="default"]');
    }

    section.dispatchEvent(
      new CustomEvent('theme:gallery:swap', {
        bubbles: true,
        detail: {
          mediaHtml: mediaGroup.innerHTML,
          thumbsHtml: thumbsGroup ? thumbsGroup.innerHTML : null,
        },
      })
    );
  });

  // ── End variant media swap ────────────────────────────────────────────────
})();
